module.exports = require('./helpers/bundle-url').getBundleURL('6ZzK6') + "resources/images/favicon.png";